import React from "react";
import './WhatsappButton.css'; 
import whatsappIcon from '../../src/assets/img/WhatsAppIcon/whatsapp-icon.png'; 

const WhatsappButton = ({
  // link = "https://wa.me/+962791008716", 
  // link = "https://wa.me/+962792888850", 
  link = "https://wa.me/+962796872502", 
  altText = "WhatsApp",
  iconSize = 50,
  onClick,
}) => {
  const handleClick = (event) => {
    if (onClick) {
      event.preventDefault(); 
      onClick();
    }
  };

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsApp-button"
      onClick={handleClick}
    >
      <img
        src={whatsappIcon}
        alt={altText}
        style={{ width: iconSize, height: iconSize }}
      />
    </a>
  );
};

export default WhatsappButton;
